module.exports = __webpack_public_path__ + "static/media/hospedagem-animacao.9c64df43.webm";